module.exports = __webpack_public_path__ + "static/homepage-technobis-cb785ef7f24e64708ffbd79ed989b58a.png";